var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"spinner-container"},[_c('div',{staticClass:"spinner",class:_vm.size})])
}
var staticRenderFns = []

export { render, staticRenderFns }